import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../assets/logo4.png";
import { CiMenuFries } from "react-icons/ci";
import { FaTimes } from "react-icons/fa";

const links = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Programs", path: "/programs" },
  { name: "Blog", path: "/blog" },
  { name: "Contact", path: "/contact" },
  { name: "Get Involved", path: "/get-involved" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkClass = (path) =>
    `block px-3 py-1 rounded transition font-medium ${
      location.pathname === path
        ? "text-[#6A0DAD]"
        : "text-[#2D033B] hover:text-[#9B5DE5]"
    }`;

  return (
    <div
      className={`fixed top-0 left-0 w-full z-50 transition-all ${
        scrolled ? "bg-white shadow-lg" : "bg-white"
      }`}
    >
      <div className="px-6 py-4 flex justify-between items-center max-w-7xl mx-auto">
        <div className="flex flex-1 items-center ">
          <img
            src={Logo}
            alt="Queen Esther's Foundation Logo"
            className="h-16 w-auto  object-cover"
          />
          <h1 className="text-purple-800 font-bold">Queen Esther's Impact Foundation</h1>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-6 items-center">
          {links.map((link) => (
            <Link key={link.path} to={link.path} className={linkClass(link.path)}>
              {link.name}
            </Link>
          ))}

          <Link
            to="/donate"
            className="bg-[#6A0DAD] text-white px-5 py-2 rounded-md font-semibold hover:bg-[#5F0F99] transition"
          >
            Donate
          </Link>
        </div>

        {/* Mobile Toggle */}
        <button
          aria-label="Toggle Menu"
          aria-expanded={open}
          className="md:hidden text-[#2D033B] font-bold focus:outline-none"
          onClick={() => setOpen(!open)}
        >
          {open ? <FaTimes size={24} /> : <CiMenuFries size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          open ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="bg-[#F3E8FF] px-6 py-4 flex flex-col space-y-4">
          {links.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={linkClass(link.path)}
              onClick={() => setOpen(false)}
            >
              {link.name}
            </Link>
          ))}

          <Link
            to="/donate"
            className="bg-[#6A0DAD] text-white px-4 py-2 rounded-md font-semibold text-center hover:bg-[#5F0F99]"
            onClick={() => setOpen(false)}
          >
            Donate
          </Link>
        </div>
      </div>
    </div>
  );
}
